import RandomSeed from 'random-seed'

export default function getSeed (seed) {
  if (seed) {
    return seed
  }
  const rand = new RandomSeed()
  let result = ''
  for (let idx = 0; idx < 15; ++idx) {
    const res = rand(62)
    if (res < 10) {
      result += String.fromCharCode(48 + res)
    } else if (res < 36) {
      result += String.fromCharCode(65 - 10 + res)
    } else {
      result += String.fromCharCode(97 - 36 + res)
    }
  }
  return result
}
